import React from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
  topDataList,
} from "../../../../constants/SalesCustomerList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";

const GatePass = () => {
  const navigate = useNavigate();

  const handleOnAddCustomerButton = () => {
    navigate(ROUTES_NAVIGATION.ADDSALESCUSTOMER);
  };

  const handleGatePassDetails = () => {
    navigate(ROUTES_NAVIGATION.VIEWGATEPASSS)
  }

  return (
    <ListPage

    isButtonRequired={false}
      headerTopText="Sales /  Gate Paas"
      headerTitle="Gate Pass"
    //   addButtonTitle="Add Customer"
    //   uploadButtonTitle="Upload Customer"
      listTitle="All Customers"
      topDetailsList={topDataList}
      tableData={TABLE_DATA}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleOnAddButton={handleOnAddCustomerButton}
      handleOnUploadButton={() => {}}
      handleViewButton={handleGatePassDetails}
    />
  );
};

export default GatePass;
